import React from "react";
import { objectToQueryString } from "@unisearch/helpers";
import { useRouter } from "next/router";
import { NewsImageCard } from "@modules/study/common/news";
import Link from "next/link";
import styles from "./image_gallery.module.scss";

export const NewsImageGallery = ({ imageGallery }) => {
  const router = useRouter();

  const pushToGallery = () => {
    let query = objectToQueryString({
      limit: 7,
      page: 1,
      newsFormat: "gallery",
    });
    router.push({
      pathname: "/news/gallery",
      query: query,
    });
    return true;
  };

  return (
    <section className={styles.section_image_gallery}>
      <div className="container">
        <div className={styles.heading_wrapper}>
          <h2 className={styles.heading}>Image Gallery</h2>
          <button
            onClick={pushToGallery}
            className={`btn btn-outline-grey btn-md btn-round ${styles.btn_view_all}`}
          >
            View All
          </button>
        </div>
        <div className={styles.gallery_wrapper}>
          {imageGallery &&
            imageGallery?.length > 0 &&
            imageGallery?.map((item, i) => {
              return (
                <NewsImageCard
                  data={item}
                  overlay={true}
                  key={i}
                  customClasses={{
                    cardClass: styles.gallery_item,
                    headClass: styles.gallery_item_head,
                    bodyClass: styles.gallery_item_body,
                    titleClass: styles.gallery_item_title,
                    featureImageClass: styles.gallery_item_image,
                  }}
                />
              );
            })}
        </div>
      </div>
    </section>
  );
};

export default NewsImageGallery;
